import gql from 'graphql-tag';

const gbxMetaTagsQuery = gql`
  fragment gbxMetaTagsQuery on LayoutContent {
    gbxMetaTitle: vcmsAsset(
      structure: "TextAsset"
      properties: { key: "GBX_META_TITLE" }
    )
    gbxMetaDescription: vcmsAsset(
      structure: "TextAsset"
      properties: { key: "GBX_META_DESCRIPTION" }
    )
  }
`;

export default gbxMetaTagsQuery;
